import { useCurrency } from "@/contexts/CurrencyContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { DollarSign, Euro, ChevronDown } from "lucide-react";
import { TbCurrencyLira } from "react-icons/tb";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const CurrencySwitcher = () => {
  const { currency, setCurrency, isLoading } = useCurrency();
  const { t } = useLanguage();

  const getCurrencyIcon = () => {
    switch (currency) {
      case 'EUR':
        return <Euro className="w-3 h-3" />;
      case 'USD':
        return <DollarSign className="w-3 h-3" />;
      case 'TRY':
        return <TbCurrencyLira className="w-3 h-3" />;
      default:
        return <Euro className="w-3 h-3" />;
    }
  };

  return (
    <>
      {/* Desktop: buttons */}
      <div className="hidden sm:flex items-center gap-1">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setCurrency('EUR')}
          className={`h-7 px-2 text-xs font-medium transition-all ${
            currency === 'EUR' 
              ? 'bg-white/20 text-white' 
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
          disabled={isLoading}
        >
          <Euro className="w-3 h-3 mr-1" />
          EUR
        </Button>
        <span className="text-white/50">|</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setCurrency('USD')}
          className={`h-7 px-2 text-xs font-medium transition-all ${
            currency === 'USD' 
              ? 'bg-white/20 text-white' 
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
          disabled={isLoading}
        >
          <DollarSign className="w-3 h-3 mr-1" />
          USD
        </Button>
        <span className="text-white/50">|</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setCurrency('TRY')}
          className={`h-7 px-2 text-xs font-medium transition-all ${
            currency === 'TRY' 
              ? 'bg-white/20 text-white' 
              : 'text-white/70 hover:text-white hover:bg-white/10'
          }`}
          disabled={isLoading}
        >
          <TbCurrencyLira className="w-3 h-3 mr-1" />
          TRY
        </Button>
      </div>

      {/* Mobile: dropdown */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="sm:hidden">
          <Button
            variant="ghost"
            size="sm"
            className="h-6 px-1.5 text-[10px] font-medium text-white hover:bg-white/10"
            aria-label={t("Change currency") + `: ${currency}`}
            disabled={isLoading}
          >
            {getCurrencyIcon()}
            <ChevronDown className="w-2.5 h-2.5 ml-0.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[100px] bg-background">
          <DropdownMenuItem 
            onClick={() => setCurrency('EUR')}
            className={currency === 'EUR' ? 'bg-accent' : ''}
          >
            <Euro className="w-4 h-4 mr-2" />
            EUR
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setCurrency('USD')}
            className={currency === 'USD' ? 'bg-accent' : ''}
          >
            <DollarSign className="w-4 h-4 mr-2" />
            USD
          </DropdownMenuItem>
          <DropdownMenuItem 
            onClick={() => setCurrency('TRY')}
            className={currency === 'TRY' ? 'bg-accent' : ''}
          >
            <TbCurrencyLira className="w-4 h-4 mr-2" />
            TRY
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};

export default CurrencySwitcher;
